import { render } from "./UiBreadcrumbs.vue?vue&type=template&id=be168f7a"
import script from "./UiBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./UiBreadcrumbs.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__